import { NgModule } from "@angular/core";
import { DownloadComponent } from "./download/download.component";
import { EyeComponent } from "./eye/eye.component";


@NgModule({
  declarations: [DownloadComponent, EyeComponent],
  exports: [DownloadComponent, EyeComponent],
  providers: [],
})
export class IconModule {}